<template>
  <v-app>
    <nav>
      <v-app-bar style="background-color: white;" prominent app hide-on-scroll>
        <v-img @click="volver" alt="Logo" class="ml-6" src="@/assets/logo-sin-propiedades.jpg" 
        style="max-width:13rem"></v-img>
      </v-app-bar>
    </nav>
    <div class="contenedor">
      <div align="center" style="width: 100%;">
        <h1 class="titulo">¿Quiénes somos?</h1> 
        <p class="descripcion mb-8">Alfonsina Grand Propiedades es una empresa nueva en el rubro inmobiliario que nació con el fin de brindar una atención personalizada y de calidad a sus clientes, tanto en la compra y venta de inmuebles, como asi tambien en el alquiler y administración de sus propiedades</p>
      </div>

      <div style="height: 200px; width: 100%; background-color: #97b699; color: white;">
        <div class="alinear" style="width: 100%;">
          <div align="center" style="width: 40%; max-height: 100%;">
            <v-img class="icono" src="@/assets/cohete.png"></v-img>
            <h2 class="subTitulo">Misión</h2>
          </div>
          <div align="center" style="width: 60%;">
            <p class="texto mbM">Brindar una asesoría inmobiliario personalizada, orientada a cuidar el patrimonio de nuestros clientes en todas las etapas de venta, compra o renta, con ética, profesionalismo, honestidad y discreción, con el objetivo de crear un lazo comercial sólido y perdurable a lo largo del tiempo</p>
          </div>
        </div>
      </div>

      <div class="mt-8" style="height: 200px; width: 100%; background-color: #394c55; color: white;">
        <div class="alinear" style="width: 100%;">
          <div align="center" style="width: 40%;">
            <v-img class="icono" src="@/assets/ojo.png"></v-img>
            <h2 class="subTitulo">Vision</h2>
          </div>
          <div align="center" style="width: 60%;">
            <p class="texto mt-12">Ser la mejor opción en el rubro inmobiliario para quienes quieran la ayuda de un profesional, a través del respeto, la transparencia y la innovación de nuestros servicios</p>
          </div>
        </div>
      </div>

      <div class="mt-8" style="height: 200px; width: 100%; background-color: #97b699; color: white;">
        <div style="width: 100%;">
          <div class="alinear" style="justify-content: center; width: 100%; height: 125px;">
            <div class="icono pt-0 mt-0">
              <v-img class="icono" src="@/assets/balansa.png"></v-img>
            </div>
            <h2 class="mt-8 subTitulo" >Conducta Ética</h2>
          </div>
          <div align="center" style="width: 100%; height: 75px;">
            <p class="texto textoMb">Actuamos con profesionalidad, compromiso, discreción, lealtad, honestidad y respeto</p>
          </div>
        </div>
      </div>

      <div class="mt-8" style="height: 200px; width: 100%; background-color: #394c55; color: white;">
        <div style="width: 100%;">
          <div class="alinear" style="justify-content: center; width: 100%; height: 125px;">
            <div class="icono pt-0 mt-0">
              <v-img class="icono" src="@/assets/diamante.png"></v-img>
            </div>
            <h2 class="mt-8 mr-8" style="font-family: 'Montserrat', sans-serif;">Orientación al cliente</h2>
          </div>
          <div align="center" style="width: 100%; height: 75px;">
            <p class="texto textoMb">Centramos nuestro esfuerzo en la satisfacción del cliente</p>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
  export default {
    name: 'QuienesSomos',
    methods: {
      volver () {
        this.$router.push('/')
      },
      scrollToTop () {
        window.scrollTo(0,0)
      }
    },
    mounted() {
      this.scrollToTop()
    }
  }
</script>

<style scoped>
.titulo{
  color: #97b699; 
  letter-spacing: 8px;
  margin: 1rem 0;
  font-size: 40px;
  font-family: 'Montserrat', sans-serif;
}
.icono{
  width: 120px; 
  height: 115px;
}
h2{
  font-size: 40px; 
  letter-spacing: 10px;
}
.contenedor{
  margin: 1rem 10%;
}
.texto{
  margin-top: 30px;
  font-family: 'Kanit', sans-serif;
  font-weight: 900;
}
.descripcion{
  font-family: 'Kanit', sans-serif;
  font-weight: 900;
  }
.subTitulo{
  margin-left: 15px;
  font-family: 'Montserrat', sans-serif;
}
@media screen and (max-width: 700px) {
  .titulo{
    letter-spacing: 2px;
  }
  .descripcion{
    font-size:small;
  }
  .icono{
    font-size: 50px;
  }
  h2{
    font-size: 30px; 
    letter-spacing: 4px;
  }
  .texto{
    font-size: 12px;
    margin-top: 5px;
  }
  .contenedor{
    margin: 1rem 5%;
  }
  .mbM{
    margin-top: 15px;
  }
  .textoMb{
    padding-top: 20px;
  }
}
@media screen and (max-width: 376px) {
  .texto{
    font-size: 11px;
    margin-top: 5px;
  }
  .mbM{
    margin-top: 5px;
  }
}
@media screen and (max-width: 320px) {
  .texto{
    font-size: 10px;
  }
  h2{
    font-size: 28px; 
  }
}
</style>